import React from 'react'
import styled from 'styled-components'
import { SwapStyle } from '../Themes'

export const PoolCompositions = styled.div`
  display: grid;
  grid-gap: 1rem;
  grid-template-columns: repeat(3, auto);

  /* Tablets */
  @media (max-width: 960px) {
    grid-template-columns: repeat(3, auto);
  }

  /* Mobiles */
  @media (max-width: 640px) {
    grid-template-columns: repeat(3, auto);
  }
`

export const PoolComposition = styled.div`
  border:1px solid ${({ theme }) => theme.poolCompositionBorderColor};
  border-radius: 25px;
  padding:0.75rem 1.5rem 0.75rem 1.5rem;
  margin-top: 5px; // case on margin-top ?
  background-color: ${({ theme }) => theme.poolCompositionBackgroundColor};
  font-size: ${SwapStyle.normalText};
  text-align: left;
  display:flex;
  flex-direction:row;
  align-items:center;
  justify-content:center;
  justify-items:center;
  align-self:center;

  /* Mobiles */
  @media (max-width: 640px) {
    border-radius: 20px;
  }
`
export const PoolCompositionLogoSymbol = styled.div`
  display:flex;
  flex-direction:column;
  align-items:center;
  justify-content:center;
  justify-items:center;
  align-self:center;
`

export const PoolCompositionSymbol = styled.div`
  font-family: Montserrat;
  color: ${({ theme }) => theme.poolCompositionSymbolTextColor};
  pointer-events: auto;
  font-size: 1.25rem;
  text-align: end;
  align-self: center;
  padding-top:0.25rem;

  /* Mobiles */
  @media (max-width: 640px) {
    font-size: 1.25rem;
  }
`

export const PoolCompositionWeight = styled.div`
  font-family: Montserrat-Light;
  color: ${({ theme }) => theme.poolCompositionWeightTextColor};
  pointer-events: auto;
  font-size: 1.25rem;
  margin-left:0.25rem;
  text-align: end;
  align-self: end;

  /* Mobiles */
  @media (max-width: 640px) {
    font-size: 1.25rem;
  }
`
